import React, { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import { IPendingItem } from '../@types/PendingItemTypes';

interface IPendingItemContext {
  pendingItem: IPendingItem | null;
  startPlacement: (item: IPendingItem) => void;
  cancelPlacement: () => void;
}

const PendingItemContext = createContext<IPendingItemContext | undefined>(undefined);

export const usePendingItem = () => {
  const context = useContext(PendingItemContext);
  if (!context) throw new Error('usePendingItem must be used within PendingItemProvider');
  return context;
};

export const PendingItemProvider = ({ children }: { children: ReactNode }) => {
  const [pendingItem, setPendingItem] = useState<IPendingItem | null>(null);

  const startPlacement = useCallback((item: IPendingItem) => {
    setPendingItem(item);
  }, []);

  const cancelPlacement = useCallback(() => {
    setPendingItem(null);
  }, []);

  return (
    <PendingItemContext.Provider value={{ pendingItem, startPlacement, cancelPlacement }}>
      {children}
    </PendingItemContext.Provider>
  );
};